import React from 'react'
import get from 'lodash/get'
// var CircularJSON = require('circular-json')

import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import * as Actions from '../redux/actions'

class InputFile extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id      : this.props.id,
      value   : '',
      schema  : this.props.schema,
      classes : get(this.props, 'AXGClasses.input', 'form-group'),
      // floatingLabel : get(this.props, 'AXGOptions.floating-label', true),
    }
  }

  handleInputChange(e) {
    // var file = this.refs.fileInput.getDOMNode().files[0]
    // console.log(`file: ${file}`)
    // console.log(`refs: ${CircularJSON.stringify(this.refs.fileInput)}`)
    var value = e.target.value
    console.log(`value: ${value}`)
    this.setState({
      value: value,
      title: value,
    })
    this.props.actions.setAppxigonState({
      key   : [this.props.AXGKey],
      value : value,
    })
  }

  componentWillMount() {
    var component = this
    var currentValue = get(component.props.appxigonState, component.props.AXGKey,'')
    console.log(`input currentValue (${component.props.AXGKey}): ${currentValue}`);
    component.setState({
      value: currentValue,
    })
  }

  render() {
    // console.log(`input-text schema (${this.state.id}): ${JSON.stringify(this.state.schema)}`)
    var schema = this.state.schema
    var title = this.state.title
    var icon = get(schema, 'icon', null)
    var helpMessage = get(schema, 'help-message', '')
    var id = `input-${this.state.id}`
    return (
      <div
        className={
          this.state.classes +
          (this.state.floatingLabel ? ' label-floating' : '') +
          (this.props.show ? '' : ' hidden')
        }>
        <form>
          <div className='input-group'>
            {
              <span class="input-group-addon">
                <i className="material-icons">{ icon }</i>
              </span>
            }
            {
              <label htmlFor={id} className='control-label'>{title}</label>
            }
              <input
                id={id}
                type='file'
                ref='fileInput'
                className='form-control'
                value={''}
                placeholder={ this.state.floatingLabel ? '' : title }
                onChange={this.handleInputChange.bind(this)}/>
            {
              helpMessage ? <p className="help-block">{ helpMessage }</p> : null
            }
          </div>
        </form>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    appxigonState: state.AXGState,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InputFile)



// WEBPACK FOOTER //
// ./item-types/input-file.js